import logo from '../logo.svg';

import { BrowserRouter, Route, Routes } from "react-router-dom";

import '../styles/App.css';

import Materias from './Materias';
import MateriasFrontend from "./frontend/MateriasFrontend"
import Maquetado from './frontend/01-Maquetado/Maquetado'
import Funcionalidad from './frontend/02-JavaScript/Funcionalidad';

import Size from "./context/GetSize"

function App() {
  return (
    
    <>
      <BrowserRouter>

        <Routes>
          <Route path="/My-Portfolio" element={<Materias/>} ></Route>
          
          <Route path="/My-Portfolio/frontend" element={<MateriasFrontend/>} />
          <Route path="/My-Portfolio/frontend/html" element={<Maquetado/>} />
          <Route path="/My-Portfolio/frontend/javascript" element={<Funcionalidad/>} />


        </Routes>

      </BrowserRouter>

      <Size></Size>

    </>
  );
}

export default App;
